import { render, staticRenderFns } from "./TreatmentClassEdit.vue?vue&type=template&id=4af4f902&scoped=true&"
import script from "./TreatmentClassEdit.vue?vue&type=script&lang=js&"
export * from "./TreatmentClassEdit.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentClassEdit.vue?vue&type=style&index=0&id=4af4f902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4f902",
  null
  
)

export default component.exports